import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { ImageMask } from 'elements/visual/ImageMask';
import { motion } from 'framer-motion';
import { WorldMap_worldMap } from 'graphql/query/__generated__/WorldMap';
import { ANIMATION_APPEAR, conditionalScaleAnimation } from 'libs/styles/animations';
import { EColors, EFonts, EGrads, EShadows } from 'libs/styles/styling';
import { useNavigate } from 'react-router';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    map?: WorldMap_worldMap;
}

export const CreateMinuteContinue = (props: Props): JSX.Element => {
    const navigate = useNavigate();

    function redirectToMap() {
        navigate(`/minute/${props.map?.worldMapId}`);
    }

    return (
        <S_CreateMinuteContinue
            className={props.className}
            {...ANIMATION_APPEAR}
            {...conditionalScaleAnimation(true, 1.05, 1.05)}
        >
            <S_Content>
                <S_Center>
                    <S_Text>
                        {Localization.ALREADY_CREATING} <S_MapName>{props.map?.title}</S_MapName>
                    </S_Text>
                    <S_WebButton
                        shadow={EShadows.LIGHT}
                        type={'primary'}
                        text={Localization.CONTINUE_CREATING}
                        onClick={redirectToMap}
                    />
                </S_Center>
            </S_Content>
            <ImageMask randomizePosition={true} step={20} image="contour" repeat={true} />
        </S_CreateMinuteContinue>
    );
};

const S_CreateMinuteContinue = styled(motion.div)`
    width: 100%;
    border-radius: 7px;
    position: relative;
    padding: 20px 30px;
    background: ${EGrads.ACC2_GRAD};
    box-shadow: ${EShadows.STRONG};
    @media only screen and (min-width: 1260px) {
        width: 430px;
    }
`;

const S_Content = styled.div`
    z-index: 1;
`;

const S_Center = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const S_Text = styled.div`
    color: ${EColors.WHITE};
    text-align: center;
    margin-bottom: 25px;
    font-family: ${EFonts.Regular};
`;

const S_MapName = styled.span`
    font-family: ${EFonts.Bold};
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 0 0 15px 0;
`;
